import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import LiveDelhi from './liveEventLineups/LiveDelhi';

const LiveEvents = () => {
  return (
    <Fragment>
      <Container className='LiveEvents-block  text-light pl-0'>
        <Row>
          <Col md={6}>
            <h2 className='mb-3'>Throwdown Chapter V: Laser Jail</h2>
          </Col>
        </Row>
        <Row className=' my-3 py-3'>
          <Col md={7}>
            <p className='text-justify'>
              Monstercat Presents at Chasing Summer Music Festival! Prepare for
              this powerhouse lineup: Feed Me, Crankdat, Habstrakt, MODESTEP,
              RIOT, Tokyo
            </p>
          </Col>
        </Row>
      </Container>
      <Container fluid className='LiveEvents-block-btns'>
        <Row className='text-light'>
          <Col className='py-1 btn live-btns'>
            Delhi <p className='m-0'>12 March</p>
          </Col>
          <Col md={1} className='p-0 live-line'>
            <span></span>
          </Col>
          <Col className='py-1 btn live-btns'>
            Mumbai <p className='m-0'>13 March</p>
          </Col>
          <Col md={1} className='p-0 live-line'>
            <span></span>
          </Col>
          <Col md={1.8} className='py-1 btn live-btns'>
            Chandigarh <p className='m-0'>15 March</p>
          </Col>
          <Col md={1} className='p-0 live-line'>
            <span></span>
          </Col>
          <Col className='py-1 btn live-btns'>
            Pune <p className='m-0'>17 March</p>
          </Col>
          <Col md={4} className='p-0 live-line'>
            <span></span>
          </Col>
        </Row>
        <Row className='my-2 live_Event-text'>
          <h2 className='text-capitalize mt-4 ml-2 py-2'>lineup</h2>
        </Row>
        <LiveDelhi />
        {/* <Row className='my-2 live_Event-text'>
          <h2 className='text-capitalize mt-4 mb-0 ml-2 pt-2 pb-0'>venue</h2>
        </Row>
        <div className='text-light my-1 live_Event-text'>
          <h4 className='text-capitalize mt-2 mb-0 ml-0 py-2'>Kitty Su</h4>
          <p className='mb-0'>Barakhamba Road </p>
          <p>Delhi</p>
        </div> */}
        <NavLink to='/buyTickets' className='btn btn-theam'>
          buy tickets
        </NavLink>
      </Container>
    </Fragment>
  );
};

export default LiveEvents;
